import { window } from '@wix/photography-client-lib';
export function replaceWindowElement(_a) {
    var type = _a.type, id = _a.id, attributes = _a.attributes, innerHTML = _a.innerHTML, parentElement = _a.parentElement;
    var removedElement = window.document.getElementById(id);
    if (removedElement) {
        var parent_1 = removedElement.parentNode;
        parent_1.removeChild(removedElement);
    }
    var addedElement = window.document.createElement(type);
    addedElement.setAttribute('id', id);
    Object.keys(attributes).forEach(function (key) {
        return addedElement.setAttribute(key, attributes[key]);
    });
    if (innerHTML) {
        addedElement.innerHTML = innerHTML;
    }
    parentElement.appendChild(addedElement);
}
//# sourceMappingURL=replaceWindowElement.js.map